angular
	.module 'App.Module.VoucherTypes', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'voucher_types',
				url: '/voucher_types',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@voucher_types':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Vouchers'
					searchParams:
						repositoryName: 'VoucherTypeRepository'
						title: 'wbo.voucher.type'

			.state 'voucher_types.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					vatRates: (VatRateRepository, ConfigurationService) ->
						if ConfigurationService.isEnabled 'Shared.Setting.VatRate.Enabled'
							return VatRateRepository.getEntities()

						return []
					priceRegions: (PriceRegionRepository) ->
						return PriceRegionRepository.getEntities()
					voucherType: (VoucherTypeRepository, $stateParams) ->
						query = VoucherTypeRepository.createQuery()
						query.with(
							'product',
							'product>translations',
							'product>product_data',
							'product>product_categories',
							'eligible_sets',
							'eligible_sets>products',
							'eligible_sets>products>product_variants',
							{property: 'eligible_sets>product_variants', type: 'id'},
							'eligible_sets>product_categories'
						)

						return VoucherTypeRepository.getEntity($stateParams.id, query)

			.state 'voucher_types.edit.details',
					url: '/edit',
					views:
						entity_sub_view:
							controller: 'VoucherTypeController'
							controllerAs: 'vm'
							templateUrl: '@app/voucher-type/voucher-type.view.html'
